import type { Entity } from '@backstage/catalog-model';

export interface EntityFieldsProps {
  entity: Entity;
}

import { EntityDescription } from './EntityDescription';
import { EntityBasicInfo } from './EntityBasicInfo';
import { EntityTags } from './EntityTags';

export const EntityFields: React.FC<EntityFieldsProps> = ({ entity }) => (
  <>
    <EntityDescription entity={entity} />
    <EntityBasicInfo entity={entity} />
    <EntityTags entity={entity} />
  </>
);
